import React from 'react';
import SharedNotificationsWidget from './SharedNotificationsWidget';

const Unread = () => (
  <SharedNotificationsWidget
    friendlyCollectionName="unread notifications"
    fetchNotificationsUrl="/agent_portal/api/passive_app_notifications/unread"
    refreshOnDismissAll
  />
);

export default Unread;
